import { ITag } from '../../../../common';
import { PargodaTagsEditor, TagModelName } from '../../../base-components';
import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellTags.styles';

interface Props extends IBaseCellsProps {
    data: {
        objectId: number;
        modelName: TagModelName;
        appliedTags: Array<ITag>;
        disabled?: boolean;
    };
}
const CellTags = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;

    return (
        <StyledTableCell
            onClick={(e) => {
                e.stopPropagation();
            }}
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            <PargodaTagsEditor
                objectId={Number(data.objectId)}
                modelName={data.modelName}
                externalAppliedTags={data.appliedTags}
                isInTableRow
                disabled={!!data.disabled}
            />
        </StyledTableCell>
    );
};

export default CellTags;
